import React, { Component } from 'react';
import _ from 'lodash';
import { Helmet } from 'react-helmet';
import '@mescius/wijmo.styles/wijmo.css';
import '@mescius/wijmo.cultures/wijmo.culture.ja';
import { FlexGrid, FlexGridCellTemplate } from '@mescius/wijmo.react.grid';
import { CollectionView } from '@mescius/wijmo';
import { Tooltip, PopupPosition } from '@mescius/wijmo';

import { ToolTip } from '../components/ProgressBase';
import { Confirmation } from '../components/modals/common';
import { MasterPageHeader } from '../components/PageHeader';
import FieldItemService from '../services/FieldItems';
import ProgressService from '../services/Progress';
import FieldService from '../services/Fields';
import SessionStorageService from '../services/utilities/SessionStorageService';
import {
  DISPLAY_FLAG,
  HEADER_CONSTANTS_PROGRESS,
  NUMBER_OF_FIELD_ITEM_TYPE,
  PROGRESS_REQUEST_PARAMS,
  TITLE_BROWSER_PROGRESS,
} from '../utilities/constants';
import {
  COLUMN_REQUIRE,
  INIT_POSITION,
  POSITION_OF_COLUMN,
  SETTING_COLUMN_NAME,
  VIEW_RANGE_BOTTOM_HEIGHT,
  setMaxHeightTable,
} from '../utilities/constWijmo';
import { messageUtility } from '../utilities/messageUtility';
import IconProgress from '../images/icon-progress.svg';
import { CustomMergeManager } from './ProgressSchedule';

export class ProgressSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listItems: [],
      listColumnGroups: SETTING_COLUMN_NAME,
      listClasses: [],
      listInstancesOfClassA: [],
      listInstancesOfClassB: [],
      listInstancesOfClassC: [],
      listInstancesOfClassD: [],
      listClassIds: [null],
      params_schedule: {
        offset: PROGRESS_REQUEST_PARAMS.offset,
        limit: PROGRESS_REQUEST_PARAMS.limit,
      },
      newListItems: [],
      notHaveItems: true,
      total: null,
      messageError: null,
      isShowPopupError: false,
      isScrollFlag: false,
      isTableLoading: true,
    };
    this.fieldId = SessionStorageService.getFieldId();
    this.tooltip = new Tooltip({
      showAtMouse: true,
      isContentHtml: false,
    });
    this.currentRow = INIT_POSITION;
    this.isGettingDataFlag = true;
    this.isProgressFlg = parseInt(SessionStorageService.getUseProgressFlag());
    this.strongNotification = SessionStorageService.getStrongtNotificationCount();
  }

  componentDidMount() {
    if (!this.isProgressFlg) {
      return window.location.replace('/error-permission');
    }
    SessionStorageService.removeWorkTypeSetting();
    this.handleReloadComponent();
  }

  getListClasses = async () => {
    const listClasses = [];
    const listClassIds = [];
    const response = await FieldService.fieldItem(this.fieldId);
    if (response.result) {
      const data = _.get(response, 'data.entities.field_item');
      for (
        let i = NUMBER_OF_FIELD_ITEM_TYPE.itemA;
        i <= NUMBER_OF_FIELD_ITEM_TYPE.itemD;
        i++
      ) {
        const displayFlg = _.get(data, `field_item_list${i}_display_flag`);
        let isChecked = false;
        const savedClass = this.getSavedClass(i);
        if (savedClass.isExist && _.isEqual(displayFlg, DISPLAY_FLAG.use.id)) {
          isChecked = savedClass.isChecked;
        }
        listClasses.push({
          id: i,
          name: _.get(data, `field_item_list${i}_title`),
          isChecked,
          isVisible: _.get(data, `field_item_list${i}_display_flag`),
        });
        listClassIds.push(i);
      }
      this.setState({ listClasses, listClassIds }, () => {
        this.setValueStoreSession();
      });
    }
  };

  getListInstanceByClasses = async () => {
    const params = {
      is_limit: PROGRESS_REQUEST_PARAMS.isNoLimit,
      item_list_ids: this.state.listClassIds,
      display_flag: PROGRESS_REQUEST_PARAMS.isLimit,
    };
    const response = await FieldItemService.list(this.fieldId, params);
    if (response.result) {
      const data = _.get(response, 'data.entities');
      this.setState({
        listInstancesOfClassA: data.field_item_a_lists,
        listInstancesOfClassB: data.field_item_b_lists,
        listInstancesOfClassC: data.field_item_c_lists,
        listInstancesOfClassD: data.field_item_d_lists,
      });
    }
  };

  getListFieldWorkTypes = async (loadMore = false) => {
    const response = await ProgressService.getProgressFieldWorkTypes(
      this.fieldId,
      this.state.params_schedule
    );
    if (response.result) {
      const data = _.get(response, 'data.entities.field_work_types');
      const listItems = [];
      _.forEach(data, item => {
        const {
          a_item_list_required_flag,
          b_item_list_required_flag,
          c_item_list_required_flag,
          d_item_list_required_flag,
          man_day_input_flag,
          progress_work_type_setting_id,
          field_main_work_type_id,
          main_work_type_name,
          field_sub_work_type_id,
          sub_work_type_name,
          unit_name,
          a_item_ids,
          b_item_ids,
          c_item_ids,
          d_item_ids,
        } = item;
        let input_type = '歩掛';
        let required_a_item_flag = '';
        let required_b_item_flag = '';
        let required_c_item_flag = '';
        let required_d_item_flag = '';
        if (man_day_input_flag) {
          input_type = '人工';
        }
        if (a_item_list_required_flag) {
          required_a_item_flag = '必須';
        }
        if (b_item_list_required_flag) {
          required_b_item_flag = '必須';
        }
        if (c_item_list_required_flag) {
          required_c_item_flag = '必須';
        }
        if (d_item_list_required_flag) {
          required_d_item_flag = '必須';
        }
        listItems.push({
          id: progress_work_type_setting_id,
          field_main_work_type_id,
          main_work_type_name,
          field_sub_work_type_id,
          sub_work_type_name,
          unit_name,
          input_type,
          required_a_item_flag,
          required_b_item_flag,
          required_c_item_flag,
          required_d_item_flag,
          isExistValueOfClassA: false,
          isExistValueOfClassB: false,
          isExistValueOfClassC: false,
          isExistValueOfClassD: false,
          listInstancesOfClassA: [],
          listInstancesOfClassB: [],
          listInstancesOfClassC: [],
          listInstancesOfClassD: [],
          a_item_ids,
          b_item_ids,
          c_item_ids,
          d_item_ids,
        });
      });
      const params_schedule = _.cloneDeep(this.state.params_schedule);
      params_schedule.offset += PROGRESS_REQUEST_PARAMS.limit;
      const total = _.get(response, 'data.total');
      if (loadMore) {
        return this.setState(
          {
            newListItems: listItems,
            params_schedule,
          });
      }
      return this.setState(
        {
          notHaveItems: _.isEmpty(listItems),
          listItems: new CollectionView(listItems),
          total,
          params_schedule,
        },
        () => {
          this.isGettingDataFlag = true;
          this.handleAddColumnOfInstances();
        }
      );
    }
  };

  getSavedClass = classId => {
    const savedClass = {
      name: null,
      isChecked: false,
      isExist: false,
    };
    const listCheckedClasses = SessionStorageService.getListCheckedClasses();
    const savedFieldItem = _.find(listCheckedClasses, item =>
      _.isEqual(item.fieldId, Number(this.fieldId))
    );
    if (savedFieldItem) {
      const checkedClass = _.find(savedFieldItem.params, item =>
        _.isEqual(item.id, classId)
      );
      if (checkedClass) {
        const { name, isChecked } = checkedClass;
        savedClass.name = name;
        savedClass.isChecked = isChecked;
        savedClass.isExist = true;
      }
    }
    return savedClass;
  };

  handleReloadComponent = async () => {
    await this.getListClasses();
    await this.getListInstanceByClasses();
    await this.getListFieldWorkTypes();
    this.setState(
      {
        isTableLoading: false,
      },
      () => this.handleAutoSizeColumns()
    );
  };

  handleVisibleDialogError = () => {
    this.setState({
      isShowPopupError: false,
    });
  };

  handleAddNewData = async () => {
    if (_.isUndefined(this.flexGrid.itemsSource)) {
      return;
    }
    const { _src } = this.flexGrid.itemsSource;
    const { total, params_schedule } = this.state;
    this.isGettingDataFlag = false;
    if (params_schedule.offset >= total) {
      return;
    }
    await this.getListFieldWorkTypes(true);
    this.setDataTable(_src, this.state.newListItems);
  };

  handlePushInstance = id => {
    const { itemA, itemB, itemC, itemD } = NUMBER_OF_FIELD_ITEM_TYPE;
    const {
      listInstancesOfClassA,
      listInstancesOfClassB,
      listInstancesOfClassC,
      listInstancesOfClassD,
    } = this.state;
    switch (id) {
      case itemA:
        this.setValueOfInstance(
          listInstancesOfClassA,
          'listInstancesOfClassA',
          'isExistValueOfClassA',
          'a_item_ids'
        );
        break;
      case itemB:
        this.setValueOfInstance(
          listInstancesOfClassB,
          'listInstancesOfClassB',
          'isExistValueOfClassB',
          'b_item_ids'
        );
        break;
      case itemC:
        this.setValueOfInstance(
          listInstancesOfClassC,
          'listInstancesOfClassC',
          'isExistValueOfClassC',
          'c_item_ids'
        );
        break;
      case itemD:
        this.setValueOfInstance(
          listInstancesOfClassD,
          'listInstancesOfClassD',
          'isExistValueOfClassD',
          'd_item_ids'
        );
        break;
    }
  };

  handleCheckStatusClass = async (isChecked, id) => {
    const { listClasses } = this.state;
    const indexOfClass = _.findIndex(listClasses, item =>
      _.isEqual(item.id, id)
    );
    let isChangedStatus = false;
    if (isChecked) {
      const response = await FieldService.fieldItem(this.fieldId);
      const latestClassesList = [];
      if (response.result) {
        const fieldItem = _.get(response, 'data.entities.field_item');
        for (
          let i = NUMBER_OF_FIELD_ITEM_TYPE.itemA;
          i <= NUMBER_OF_FIELD_ITEM_TYPE.itemD;
          i++
        ) {
          latestClassesList.push({
            id: i,
            name: _.get(fieldItem, `field_item_list${i}_title`),
            isVisible: _.get(fieldItem, `field_item_list${i}_display_flag`),
          });
        }
      }
      if (
        !_.isEqual(
          listClasses[indexOfClass].isVisible,
          latestClassesList[indexOfClass].isVisible
        )
      ) {
        isChangedStatus = true;
      }
    }
    return isChangedStatus;
  };

  handleDisplayClass = async (
    id,
    isChecked = true,
    isChangedStatus = false
  ) => {
    const newListClasses = _.map(this.state.listClasses, item => {
      return _.isEqual(item.id, id) ? { ...item, isChecked } : item;
    });
    if (isChangedStatus) {
      const isChangedStatus = await this.handleCheckStatusClass(isChecked, id);
      if (isChangedStatus) {
        return this.setState({
          params_schedule: {
            ...this.state.params_schedule,
            offset: PROGRESS_REQUEST_PARAMS.offset,
          },
          isShowPopupError: true,
          messageError:
            '登録内容が変更されました。\n画面を再読み込み後、再度操作を行なってください。',
        });
      }
      this.setState({ listClasses: newListClasses }, () => {
        this.setValueStoreSession();
      });
    }
    if (!isChecked) {
      this.flexGrid.scrollIntoView(
        this.currentRow,
        POSITION_OF_COLUMN.input_type
      );
    }
    this.handleVisibleColumn(id, isChecked);
  };

  handleRedirectToSettingLocation = async context => {
    const { field_main_work_type_id, field_sub_work_type_id } = context;
    const response = await ProgressService.getProgressWorkTypeSettings(
      this.fieldId,
      {
        field_main_work_type_id,
        field_sub_work_type_id,
      }
    );
    if (response.result) {
      const id = !_.isNull(field_sub_work_type_id)
        ? { field_main_work_type_id, field_sub_work_type_id }
        : { field_main_work_type_id };
      SessionStorageService.setWorkTypeSetting(id);
      window.location.href = '/progress/0:1/0/0/ProgressSettingLocation:1/0:0';
    } else {
      this.setState({
        params_schedule: {
          ...this.state.params_schedule,
          offset: PROGRESS_REQUEST_PARAMS.offset,
        },
        isShowPopupError: true,
        messageError: response.data.message,
      });
    }
  };

  handleVisibleColumn = (id, isVisible) => {
    _.forEach(this.flexGrid.columns, column => {
      if (
        (_.isEqual(id, NUMBER_OF_FIELD_ITEM_TYPE.itemA) &&
          _.isEqual(column.cssClass, 'wj-class-a')) ||
        (_.isEqual(id, NUMBER_OF_FIELD_ITEM_TYPE.itemB) &&
          _.isEqual(column.cssClass, 'wj-class-b')) ||
        (_.isEqual(id, NUMBER_OF_FIELD_ITEM_TYPE.itemC) &&
          _.isEqual(column.cssClass, 'wj-class-c')) ||
        (_.isEqual(id, NUMBER_OF_FIELD_ITEM_TYPE.itemD) &&
          _.isEqual(column.cssClass, 'wj-class-d'))
      ) {
        column.visible = isVisible;
      }
    });
  };

  handleCreateNewListColumns = (listItems, listInstances, cssClass) => {
    const cssClassAll = 'wj-align-center wj-text-color wj-background';
    const listColumns = _.map(listItems, (item, index) => {
      return {
        header: item.name,
        binding: `${listInstances}[${index}].value`,
        isReadOnly: true,
        cssClass,
        cssClassAll,
        minWidth: 50,
      };
    });
    return listColumns;
  };

  handleFilterListInstances = id => {
    const {
      listInstancesOfClassA,
      listInstancesOfClassB,
      listInstancesOfClassC,
      listInstancesOfClassD,
    } = this.state;
    let value;
    const instanceOfClassA = this.handleCreateNewListColumns(
      listInstancesOfClassA,
      'listInstancesOfClassA',
      'wj-class-a'
    );
    const instanceOfClassB = this.handleCreateNewListColumns(
      listInstancesOfClassB,
      'listInstancesOfClassB',
      'wj-class-b'
    );
    const instanceOfClassC = this.handleCreateNewListColumns(
      listInstancesOfClassC,
      'listInstancesOfClassC',
      'wj-class-c'
    );
    const instanceOfClassD = this.handleCreateNewListColumns(
      listInstancesOfClassD,
      'listInstancesOfClassD',
      'wj-class-d'
    );
    switch (id) {
      case NUMBER_OF_FIELD_ITEM_TYPE.itemB:
        value = [
          {
            ...COLUMN_REQUIRE,
            cssClass: 'wj-class-b',
            binding: 'required_b_item_flag',
          },
          ...instanceOfClassB,
        ];
        break;
      case NUMBER_OF_FIELD_ITEM_TYPE.itemC:
        value = [
          {
            ...COLUMN_REQUIRE,
            cssClass: 'wj-class-c',
            binding: 'required_c_item_flag',
          },
          ...instanceOfClassC,
        ];
        break;
      case NUMBER_OF_FIELD_ITEM_TYPE.itemD:
        value = [
          {
            ...COLUMN_REQUIRE,
            cssClass: 'wj-class-d',
            binding: 'required_d_item_flag',
          },
          ...instanceOfClassD,
        ];
        break;
      default:
        value = [
          {
            ...COLUMN_REQUIRE,
            cssClass: 'wj-class-a',
            binding: 'required_a_item_flag',
          },
          ...instanceOfClassA,
        ];
        break;
    }
    return value;
  };

  handleAddColumnOfInstances = () => {
    const { listClasses } = this.state;
    const listColumns = _.map(listClasses, item => {
      const { id, name } = item;
      const listInstances = this.handleFilterListInstances(id);
      return {
        header: name,
        columns: [...listInstances],
      };
    });
    this.setState(
      {
        listColumnGroups: [...SETTING_COLUMN_NAME, ...listColumns],
      },
      () => {
        this.handleAutoSizeColumns();
        _.forEach(listClasses, item => {
          const { id, isChecked } = item;
          this.handleDisplayClass(id, isChecked);
          this.handlePushInstance(id);
        });
      }
    );
  };

  handleAutoSizeColumns = () => {
    this.flexGrid.refresh();
    this.flexGrid.autoSizeColumns(
      POSITION_OF_COLUMN.main_work_type,
      POSITION_OF_COLUMN.sub_work_type
    );
    this.flexGrid.autoSizeColumns(POSITION_OF_COLUMN.input_type);
  };

  setHeightScrollTable = flexGrid => {
    const scrollPosition =
      flexGrid.scrollSize.height + flexGrid.scrollPosition.y;
    const heightGrid = Math.abs(scrollPosition - flexGrid.clientSize.height);
    const { params_schedule, total } = this.state;
    if (heightGrid < VIEW_RANGE_BOTTOM_HEIGHT) {
      if (params_schedule.offset >= total) {
        return;
      }
      if (this.isGettingDataFlag) {
        this.handleAddNewData();
      }
    }
  };

  setDataTable = (oldListItems, newListItems) => {
    const { listClasses } = this.state;
    this.setState(
      {
        listItems: new CollectionView(_.concat(oldListItems, newListItems)),
      },
      () => {
        this.isGettingDataFlag = true;
        this.handleAutoSizeColumns();
        _.forEach(listClasses, item => {
          const { id, isChecked } = item;
          this.handleDisplayClass(id, isChecked);
          this.handlePushInstance(id);
        });
      }
    );
  };

  setMaxHeightGrid = () => {
    const divFixed = document.querySelector('.ProgressSetting .wj-flexgrid');
    if (divFixed) {
      const params = {
        heightOfTable: 'calc(100vh - 205px)',
        heightOfTableHaveNoti: 'calc(100vh - 245px)',
        heghtOfTableIpad: 'calc(100vh - 300px)',
        heightOfTableIpadHaveNoti: 'calc(100vh - 340px)',
      };
      setMaxHeightTable(divFixed, params);
    }
  };

  setNewTooltip = (domCell, text) => {
    this.tooltip.setTooltip(domCell, text, PopupPosition.Right);
  };

  setValueOfInstance = (
    listInstances,
    listInstancesOfClass,
    isExistValue,
    itemIds
  ) => {
    let instancesOfClass = [];
    _.forEach(this.flexGrid.rows, row => {
      if (!row.dataItem[isExistValue]) {
        instancesOfClass = this.setNewListInstances(
          listInstances,
          row.dataItem[itemIds]
        );
        row.dataItem[isExistValue] = true;
        row.dataItem[listInstancesOfClass] = instancesOfClass;
      }
    });
  };

  setNewListInstances = (listInstances, listItemIds) => {
    const newListInstances = _.map(listInstances, instance => {
      const { id, name, display_flag } = instance;
      const value = !display_flag
        ? ''
        : _.includes(listItemIds, id)
        ? '〇'
        : 'ー';
      return { name, value };
    });
    return newListInstances;
  };

  setValueStoreSession = () => {
    const params = _.map(this.state.listClasses, item => {
      const { id, name, isChecked } = item;
      return { id, name, isChecked };
    });
    const listCheckedClasses = SessionStorageService.getListCheckedClasses();
    const newListCheckedClasses = _.filter(
      listCheckedClasses,
      item => !_.isEqual(item.fieldId, Number(this.fieldId))
    );
    const newCheckedClass = { fieldId: Number(this.fieldId), params };
    SessionStorageService.setListCheckedClasses([
      ...newListCheckedClasses,
      newCheckedClass,
    ]);
  };

  initialDataGrid = grid => {
    this.setMaxHeightGrid();
    grid.scrollPositionChanged.addHandler(flexGrid => {
      this.setState(
        {
          isScrollFlag: true,
        },
        () => {
          this.tooltip.dispose();
          this.setHeightScrollTable(flexGrid);
          this.currentRow = flexGrid.viewRange.row2;
        }
      );
    });
    grid.mergeManager = new CustomMergeManager();
    grid.rowHeaders.columns[0].width = 90;
    this.flexGrid = grid;
  };

  formatItem = (flexGrid, formatItemEvent) => {
    const domCell = formatItemEvent.cell;
    const colNumber = formatItemEvent.col;
    const columnName = flexGrid.columns[colNumber].binding;
    const rowNumber = formatItemEvent.row;
    const rowData = formatItemEvent.panel.rows[rowNumber]._data;
    const isPanelEqualCell = _.isEqual(formatItemEvent.panel, flexGrid.cells);
    if (isPanelEqualCell) {
      switch (columnName) {
        case 'main_work_type_name':
          this.setNewTooltip(domCell, rowData.main_work_type_name);
          break;
        case 'sub_work_type_name':
          this.setNewTooltip(domCell, rowData.sub_work_type_name);
          break;
      }
    }
  };

  render() {
    const {
      listItems,
      listColumnGroups,
      listClasses,
      isShowPopupError,
      messageError,
      notHaveItems,
      isTableLoading,
    } = this.state;
    return (
      <div className='master-slide-view show ProgressSetting'>
        <Helmet>
          <link rel='icon' href={IconProgress} />
          <title>{TITLE_BROWSER_PROGRESS.progressSetting}</title>
        </Helmet>
        <div className='master-slide-view__view'>
          <MasterPageHeader
            title={HEADER_CONSTANTS_PROGRESS.progressSetting}
            disableHelpMenu
          />
          <div className='master-slide-view__table'>
            <div className='ProgressSetting__header'>
              <div className='ProgressSetting__select'>
                <div className='ProgressSetting__select--wrapper'>
                  <div className='ProgressSetting__select--title'>
                    表示したい作業場所を選択してください。
                  </div>
                  <div className='ProgressSetting__select--checkbox'>
                    {_.map(listClasses, item => {
                      const { id, name, isChecked, isVisible } = item;
                      if (isVisible) {
                        return (
                          <label className='checkbox' key={id}>
                            <input
                              name='checkbox'
                              type='checkbox'
                              disabled={false}
                              checked={isChecked}
                              onChange={e =>
                                this.handleDisplayClass(
                                  id,
                                  e.target.checked,
                                  true
                                )
                              }
                            />
                            <i className='i-square i-3x' />
                            <ToolTip content={name} value={name} />
                          </label>
                        );
                      }
                    })}
                  </div>
                </div>
              </div>
            </div>
            {isTableLoading && <div className='indicator' />}
            <div style={{ visibility: isTableLoading ? 'hidden' : 'visible' }}>
              <FlexGrid
                autoGenerateColumns={false}
                itemsSource={listItems}
                columnGroups={listColumnGroups}
                frozenColumns={3}
                selectionMode='None'
                allowSorting={false}
                allowDragging={0}
                quickAutoSize={true}
                initialized={this.initialDataGrid}
                formatItem={this.formatItem}
              >
                <FlexGridCellTemplate
                  cellType='TopLeft'
                  template={() => {
                    return <span>詳細設定</span>;
                  }}
                />
                <FlexGridCellTemplate
                  cellType='RowHeader'
                  template={context => {
                    return (
                      <button
                        className='btn--sm--stay'
                        onClick={() =>
                          this.handleRedirectToSettingLocation(context.item)
                        }
                      >
                        設定
                      </button>
                    );
                  }}
                />
              </FlexGrid>
              {notHaveItems && (
                <div className='ProgressSetting__content'>
                  工種が選択されていません。「使用工種選択」ボタンから設定を行ってください。
                </div>
              )}
            </div>
          </div>
        </div>
        <Confirmation
          rootClassName='ProgressErrorDialog'
          visible={isShowPopupError}
          message={messageError}
          title={messageUtility.getMessage('E-001-402')}
          multilineText={true}
          cancelButtonText={messageUtility.getMessage('I-000-017')}
          confirmButtonText={messageUtility.getMessage('I-000-180')}
          onCancel={() => {
            this.handleVisibleDialogError();
          }}
          onConfirm={() => {
            this.handleVisibleDialogError();
            this.handleReloadComponent();
          }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ProgressSetting.jsx